// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import XngZone from "@pace/App/Components/Common/XngZone";
import React, { FC } from "react";

interface SignInPageLayoutStyles {
    container?: InjectableCss;
    rightSection?: InjectableCss;
    leftSection?: InjectableCss;
    separator?: InjectableCss;
}

export const signInPageLayout: SignInPageLayoutStyles = {};

const styles = signInPageLayout;
type Props = WidgetProps;

const SignInPageLayout: FC<Props> = ({ id }) => {
    return (
        <>
            <StyledWrapper {...styles.container} data-test-selector="SignInPageLayout">
                <StyledWrapper {...styles.leftSection}>
                    <StyledWrapper className="signInForm">
                        <XngZone contentId={id} zoneName="Content00" hint="SignInExistingAccount" />
                    </StyledWrapper>
                    <Typography {...styles.separator} as="div" className="line-seperator seperator1"></Typography>
                    <StyledWrapper className="createAccount">
                        <XngZone contentId={id} zoneName="Content01" hint="CreateAccount" />
                    </StyledWrapper>
                </StyledWrapper>
                <StyledWrapper {...styles.rightSection}>
                    <XngZone contentId={id} zoneName="Content02" hint="FancyList" />
                </StyledWrapper>
            </StyledWrapper>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: SignInPageLayout,
    definition: {
        group: "Layout" as any,
        displayName: "SignIn page layout",
        allowedContexts: ["SignInPage"],
    },
};

export default widgetModule;
